import { useState, useEffect } from 'react';

function getApiBase() {
  let apiBase = import.meta.env.VITE_API_URL;
  if (!apiBase) {
    const host = window.location.hostname;
    if (host === 'strategy.eastgrinsteadac.co.uk') {
      apiBase = 'https://strategy.eastgrinsteadac.co.uk';
    } else {
      // Preview deployments (*.egac-strategy-hub.pages.dev) and any other host.
      // The *.workers.dev subdomain is disabled on this Cloudflare account, so
      // that URL returns a 1042 edge error. Route API calls to the production
      // worker route instead; its CORS config allows preview origins.
      apiBase = 'https://strategy.eastgrinsteadac.co.uk';
    }
  }
  return apiBase;
}

export function useAuth() {
  const [token, setToken] = useState(null);
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => {
    // Check localStorage for existing session
    const storedToken = localStorage.getItem('auth_token');
    const storedEmail = localStorage.getItem('auth_email');

    if (storedToken && storedEmail) {
      setToken(storedToken);
      setEmail(storedEmail);
    }

    setLoading(false);
  }, []);

  const requestOTP = async (emailAddress) => {
    const API_BASE = getApiBase();
    try {
      const response = await fetch(`${API_BASE}/api/auth/request-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailAddress }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Failed to send OTP (${response.status})`);
      }

      return response.json();
    } catch (err) {
      if (err instanceof TypeError) {
        throw new Error('Network error. Please check your connection and try again.');
      }
      throw err;
    }
  };

  const verifyOTP = async (emailAddress, otp) => {
    const API_BASE = getApiBase();
    const response = await fetch(`${API_BASE}/api/auth/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: emailAddress, otp }),
    });

    if (!response.ok) {
      throw new Error('Invalid OTP');
    }

    const data = await response.json();
    localStorage.setItem('auth_token', data.token);
    localStorage.setItem('auth_email', data.email);
    setToken(data.token);
    setEmail(data.email);

    return data;
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_email');
    setToken(null);
    setEmail(null);
    window.location.href = '/';
  };

  return {
    token,
    email,
    loading,
    requestOTP,
    verifyOTP,
    logout,
  };
}
